import React from "react";
import PropTypes from "prop-types";

import styles from "./TypeaheadPill.css";
import Icon from "components/library/Icon";

export default function TypeaheadPill(props) {
  // For some reason react-select is overriding the click handler so here is a naive tap handler that allows removing pills on mobile.
  let dragging = false;
  const touchHandlers = {
    onTouchStart: () => {
      dragging = false;
    },
    onTouchMove: () => {
      dragging = true;
    },
    onTouchEnd: () => {
      dragging ? null : props.onRemove(props.value);
    },
  };

  return (
    <button
      disabled={props.disabled}
      className={styles.root}
      {...touchHandlers}
      onClick={() => props.onRemove(props.value)}
    >
      <span>{props.children}</span>
      <Icon name="x" className={styles.icon} />
    </button>
  );
}

TypeaheadPill.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool, // This is passed through from react-select
};
